import { Component, OnInit } from '@angular/core';
import {SettingsManagerService} from "../../services/settings-manager.service";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

@Component({
  selector: 'app-cartographic-console-page',
  templateUrl: './cartographic-console-page.component.html',
  styleUrls: ['./cartographic-console-page.component.scss']
})
export class CartographicConsolePageComponent implements OnInit {

  cartographicConsoleUrl: SafeResourceUrl;

  constructor(
    private settingsManagerService: SettingsManagerService,
    public sanitizer: DomSanitizer
  ) { }

  async ngOnInit(): Promise<void> {
    const config = await this.settingsManagerService.getCartographicConsoleConfig();
    this.cartographicConsoleUrl = this.sanitizer.bypassSecurityTrustResourceUrl(config.endpointUrl);
  }

}
